const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/components/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        mandatoryLabel: 'Bitte Pflichtfeld ausfüllen.',
        mustBeAtLeast: 'Wert muss mindestens {min} sein.',
        mustBeLeqThan: 'Wert darf höchstens {max} sein.',
        charactersRemaining: '{count} Zeichen verfügbar',
        now: 'Jetzt',
        cancel: 'Abbrechen',
        clear: 'Löschen',
        noSearchResults: 'Die Suche hat keine Resultate ergeben',
        searchOptionIsRequired: 'Bitte suchen und wählen Sie eine Option',
        formatDoesNotMatch: 'Das Format stimmt nicht überein.',
    },
    __RELATIVE_SOURCE_FILE__
);
